<template>
  <div class="communication">
    <div class="title row column-s">
      <div class="grid-9 grid-12-s text-center-s">
        COMUNICADO SUPPORTER {{ comm.id }}
      </div>
    </div>

    <CommSupporter v-if="!loader && comm.id" :comm="comm" />

    <div v-else class="column align-center justify-center">
      <Loader />
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Loader from "@/components/Loader.vue";
import CommSupporter from "@/components/CommSupporter.vue";

export default {
  name: "CommunicationSupporter",
  components: { Loader, CommSupporter },
  data() {
    return {
      loader: false,
      comm: {},
    };
  },
  beforeMount() {
    this.GET_COMM_SUPPORTER(this.$route.params.id).then((r) => {
      this.comm = r.data;
    });
  },
  methods: {
    ...mapActions("admin", ["GET_COMM_SUPPORTER"]),
  },
  mounted() {
    this.$parent.$children[0].changeMenu("communication");
  },
};
</script>

<style lang="scss" scoped>
@use "@/assets/scss/vars.scss" as *;
.communication {
  padding: 42px 35px;
  @media (max-width: $small) {
    padding: 7px;
  }

  .title {
    font-size: 26px;
    font-weight: bold;
    color: $gray-4;
    text-transform: uppercase;

    @media (max-width: $small) {
      margin-top: 38px;
      margin-bottom: 0px;
    }
  }

  .white {
    @media (max-width: $small) {
      margin-top: 1.2rem;
    }
  }
}
</style>